import React from 'react';
const stats = [{
  value: '+800',
  label: 'instructores ya lo tienen'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'MR',
  quote: '"Llevaba años improvisando cada clase. Con el MegaPack armé toda la planificación del año en un fin de semana. Mis alumnos lo notaron de inmediato y dejaron de abandonar."',
  author: '— Marcos R., Buenos Aires | Instructor de Karate, 12 años de experiencia'
}, {
  initials: 'DP',
  quote: '"Perdía horas pensando qué enseñar en cada clase. Ahora abro la agenda de 52 semanas y sé exactamente qué hacer. Mis ingresos subieron porque mis alumnos se quedan."',
  author: '— Diego P., Córdoba | Dueño de Dojo de Judo'
}, {
  initials: 'FS',
  quote: '"Se me iban alumnos y no entendía por qué. Con el sistema de retención del Tomo 2 frenó la deserción en menos de un mes. Lo que no pude hacer en años, lo resolví en semanas."',
  author: '— Federico S., Rosario | Instructor de Taekwondo'
}];
export function SocialProof() {
  return <section className="w-full px-4 py-8 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(20, 20, 28)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-265">
      <div className="mx-auto max-w-4xl" data-id="element-266">
        {/* TÍTULO DE SECCIÓN */}
        <div className="text-center mb-6" data-id="element-267"></div>

        {/* STATS */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-268">
          {stats.map(stat => <div key={stat.label} className="bg-gray-900 rounded-xl py-3 px-2 shadow-sm border border-red-900" data-id="element-269">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-white" data-id="element-270">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-red-500" data-id="element-271">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* TESTIMONIALS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-272">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-gray-900 border border-red-900 rounded-xl p-4 shadow-sm" data-id="element-273">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center bg-red-950 text-xs font-black text-red-500 rounded-full" data-id="element-274">
                {t.initials}
              </div>
              <div data-id="element-275">
                <div className="mb-1 text-[10px] text-red-400" data-id="element-276">⭐⭐⭐⭐⭐</div>
                <p className="text-xs font-medium text-gray-200 m-0" data-id="element-277">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-278">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>

        {/* BARRA DE CONFIANZA */}
      </div>
    </section>;
}